import _ from 'lodash';

const getDefaultState = () => {
  return {
    hiddenRatingPrompts: [],
    hiddenSettlementRatingPrompts: [],
  }
}

const state = getDefaultState()

const getters = {
  isOrderRatingHidden: (state) => (orderId) => {
    return state.hiddenRatingPrompts.includes(orderId);
  },
  isSettlementRatingHidden: (state) => (refiningLotId) => {
    return state.hiddenSettlementRatingPrompts.includes(refiningLotId);
  },
}

const actions = {
  hideOrderRating({ commit }, orderId) {
    commit('ADD_HIDDEN_ORDER_RATING', orderId)
  },
  showOrderRating({ commit }, orderId) {
    commit('REMOVE_HIDDEN_ORDER_RATING', orderId)
  },
  resetHiddenOrderRatings({ commit }) {
    commit('RESET_HIDDEN_ORDER_RATINGS')
  },
  hideSettlementRating({ commit }, refiningLotId) {
    commit('ADD_HIDDEN_SETTLEMENT_RATING', refiningLotId)
  },
  showSettlementRating({ commit }, refiningLotId) {
    commit('REMOVE_HIDDEN_SETTLEMENT_RATING', refiningLotId)
  },
  resetHiddenSettlementRatings({ commit }) {
    commit('RESET_HIDDEN_SETTLEMENT_RATINGS')
  },
}

const mutations = {
  ADD_HIDDEN_ORDER_RATING(state, orderId) {
    if (!state.hiddenRatingPrompts.includes(orderId)) {
      state.hiddenRatingPrompts.push(orderId);
    }
  },
  REMOVE_HIDDEN_ORDER_RATING(state, orderId) {
    if (state.hiddenRatingPrompts.includes(orderId)) {
      _.remove(state.hiddenRatingPrompts, (id) => id === orderId);
    }
  },
  RESET_HIDDEN_ORDER_RATINGS(state) {
    state.hiddenRatingPrompts = [];
  },
  ADD_HIDDEN_SETTLEMENT_RATING(state, refiningLotId) {
    if (!state.hiddenSettlementRatingPrompts.includes(refiningLotId)) {
      state.hiddenSettlementRatingPrompts.push(refiningLotId);
    }
  },
  REMOVE_HIDDEN_SETTLEMENT_RATING(state, refiningLotId) {
    if (state.hiddenSettlementRatingPrompts.includes(refiningLotId)) {
      _.remove(state.hiddenSettlementRatingPrompts, (id) => id === refiningLotId);
    }
  },
  RESET_HIDDEN_SETTLEMENT_RATINGS(state) {
    state.hiddenSettlementRatingPrompts = [];
  },
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
}
